import CryptoJS from 'crypto-js'

export function hash256(string) {
    const utfParse = CryptoJS.enc.Utf8.parse(string);
    return CryptoJS.SHA256(utfParse).toString();
}